
import { isBlank } from 'vessel/utils'

export default {
  name: 'VsWrap',
  functional: true,
  props: {
    with: {
      type: String,
      required: true
    },
    if: {
      type: [Boolean, String, Object, Array, Date],
      default: null
    }
  },
  render(h, { props, data, children }) {
    if (isBlank(props.if)) {
      return children
    } else {
      return h(props.with, data, children)
    }
  }
}
